import React from 'react'
import PropTypes from 'prop-types'
import {
  Button, Card, Container, Display3, Display4, SearchInput
} from '@sainsburys-tech/fable'
import { ChevronRight } from '@sainsburys-tech/icons'
import errorIcon from '../../../assets/error.png'

class WorkOrders extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      workOrders: [],
      searchWorkOrderList: [],
      searchKeyword: '',
      currentPage: 1,
    }
  }

  pageSize = 10

  componentDidMount = () => {
    const {
      setHeaderBurger,
      setHeaderBack,
      setSignOutHeader,
      setWorkOrder,
      workOrders,
      match,
    } = this.props
    const { withbackbutton } = match.params

    if (withbackbutton === 'true') {
      setHeaderBack()
    } else {
      setHeaderBurger()
    }
    setWorkOrder(null)
    setSignOutHeader(true)

    this.setState({ workOrders, currentPage: 1 })
  };

  onSearchWorkorders = (search) => {
    const normalisedSearch = (search || '').trim()

    const { workOrders } = this.state
    const searchWorkOrderList = normalisedSearch
      ? workOrders.filter(workOrder => (workOrder.workOrderNumber || '').includes(normalisedSearch))
      : []

    this.setState({
      searchKeyword: normalisedSearch,
      searchWorkOrderList,
      currentPage: 1,
    })
  }

  handleWorkOrderKeyDown = (event, workOrder) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.handleWorkOrderSelection(workOrder)
    }
  }

  getListToDisplay = () => {
    const { workOrders, searchWorkOrderList, searchKeyword } = this.state
    const hasSearch = Boolean(searchKeyword && searchKeyword.length > 0)
    return {
      hasSearch,
      listToDisplay: hasSearch ? searchWorkOrderList : workOrders,
    }
  }

  getPagedList = (listToDisplay) => {
    const { currentPage } = this.state
    const totalItems = listToDisplay.length
    const totalPages = Math.max(1, Math.ceil(totalItems / this.pageSize))
    const safePage = Math.min(Math.max(currentPage, 1), totalPages)

    const startIndex = (safePage - 1) * this.pageSize
    const endIndex = startIndex + this.pageSize

    return {
      currentPage: safePage,
      totalItems,
      totalPages,
      pageItems: listToDisplay.slice(startIndex, endIndex),
    }
  }

  setPage = (page) => {
    this.setState({ currentPage: page })
  }

  renderWorkOrderCards = listToDisplay => listToDisplay.map(workOrder => (
    <Card
      key={workOrder.workOrderNumber}
      orientation="horizontal"
      hasBorder
      contentAlignment="left"
      className="dsib-workOrders__card"
      role="button"
      tabIndex={0}
      onClick={() => this.handleWorkOrderSelection(workOrder)}
      onKeyDown={event => this.handleWorkOrderKeyDown(event, workOrder)}
    >
      <Card.Content
        label={workOrder.workOrderNumber}
        labelSize="Display3"
        supportingText={workOrder.companyName}
      />
      <Card.Actions className="dsib-workOrders__cardAction">
        <ChevronRight aria-hidden="true" focusable="false" />
      </Card.Actions>
    </Card>
  ))

  handleWorkOrderSelection = (workOrder) => {
    const { history, setWorkOrder } = this.props
    setWorkOrder(workOrder.workOrderNumber, workOrder.companyName)

    history.push('/AssessmentStatements')
  };

  handleDoSomethingElse = () => {
    const { history, setWorkOrder } = this.props
    setWorkOrder(null)
    history.push('/WorkOrderHome')
  };

  render() {
    const { hasSearch, listToDisplay } = this.getListToDisplay()
    const { currentPage, totalPages, pageItems } = this.getPagedList(listToDisplay)
    const showEmptyState = hasSearch && listToDisplay.length === 0

    return (
      <Container className="dsib-workOrders">
        <div className="dsib-workOrders__heading">
          <Display4>Select the work order that you&#39;ve come to do</Display4>
        </div>

        <div className="dsib-workOrders__search">
          <SearchInput
            label="Find a work order"
            placeholder="Find a work order"
            hasHiddenLabel
            leadingIcon
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            onChange={(value) => {
              const digitsOnly = (value || '').replace(/\D/g, '')
              this.onSearchWorkorders(digitsOnly)
            }}
            onSubmit={(value, event) => {
              event?.preventDefault()
              const digitsOnly = (value || '').replace(/\D/g, '')
              this.onSearchWorkorders(digitsOnly)
            }}
          />
        </div>

        <div className="dsib-workOrders__list">
          {showEmptyState ? (
            <div className="dsib-workOrders__empty">
              <div className="dsib-workOrders__emptyIcon">
                <img src={errorIcon} alt="" />
              </div>
              <p className="dsib-workOrders__emptyText">
                Sorry, we can't find this work order
              </p>
            </div>
          ) : (
            this.renderWorkOrderCards(pageItems)
          )}
        </div>

        {!showEmptyState && totalPages > 1 ? (
          <div className="dsib-workOrders__pagination" aria-label="Work orders pagination">
            <Button
              variant="secondary"
              onClick={() => this.setPage(currentPage - 1)}
              disabled={currentPage <= 1}
              aria-label="Previous page"
            >
              Previous
            </Button>
            <div className="dsib-workOrders__pageInfo" aria-live="polite">
              Page
              {' '}
              {currentPage}
              {' '}
              of
              {' '}
              {totalPages}
            </div>
            <Button
              variant="secondary"
              onClick={() => this.setPage(currentPage + 1)}
              disabled={currentPage >= totalPages}
              aria-label="Next page"
            >
              Next
            </Button>
          </div>
        ) : null}

        <div className="dsib-workOrders__ctaWrap">
          <Button
            variant="secondary"
            isFullWidth
            className="dsib-workOrders__cta"
            onClick={this.handleDoSomethingElse}
          >
            I&#39;ve come to do something else
          </Button>
        </div>
      </Container>
    )
  }
}

WorkOrders.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  setHeaderBurger: PropTypes.func.isRequired,
  setHeaderBack: PropTypes.func.isRequired,
  setWorkOrder: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  workOrders: PropTypes.arrayOf(
    PropTypes.shape({
      workOrderNumber: PropTypes.string,
    }).isRequired
  ).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      withbackbutton: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export default WorkOrders
